import { useState, useCallback } from "react"
import { ChatViewer } from "../interfaces"

const LS_KEY = "chat_viewer:viewed_chats"

// chatId -> количество сообщений в момент последнего просмотра
type ViewedChatsMap = Record<string, number>

interface UseViewedChatsReturn {
  viewedChats: ViewedChatsMap
  markChatViewed: (chatId: string, count: number) => void
  getNewMessagesCount: (chat: ChatViewer.Chat) => number
  isViewed: (chatId: string) => boolean
}

export function useViewedChats(): UseViewedChatsReturn {
  const [viewedChats, setViewedChats] = useState<ViewedChatsMap>(() => {
    try {
      const stored = localStorage.getItem(LS_KEY)
      return stored ? (JSON.parse(stored) as ViewedChatsMap) : {}
    } catch {
      return {}
    }
  })

  const markChatViewed = useCallback((chatId: string, count: number) => {
    setViewedChats((prev) => {
      const next = { ...prev, [chatId]: count }
      try {
        localStorage.setItem(LS_KEY, JSON.stringify(next))
      } catch {
        // ignore quota errors
      }
      return next
    })
  }, [])

  const getNewMessagesCount = useCallback(
    (chat: ChatViewer.Chat): number => {
      const viewedCount = viewedChats[chat.chat_id]
      if (viewedCount === undefined) return 0
      return Math.max(0, chat.messages.length - viewedCount)
    },
    [viewedChats],
  )

  const isViewed = useCallback(
    (chatId: string): boolean => {
      return chatId in viewedChats
    },
    [viewedChats],
  )

  return { viewedChats, markChatViewed, getNewMessagesCount, isViewed }
}
